import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

type TeamDashboardWalkthroughContextValue = {
  manualTeamDashboardRequest: number;
  requestManualTeamDashboardWalkthrough: () => void;
};

const TeamDashboardWalkthroughContext = createContext<TeamDashboardWalkthroughContextValue | null>(
  null,
);

export function TeamDashboardWalkthroughProvider({ children }: { children: ReactNode }) {
  const [manualTeamDashboardRequest, setManualTeamDashboardRequest] = useState(0);

  const requestManualTeamDashboardWalkthrough = useCallback(() => {
    setManualTeamDashboardRequest((n) => n + 1);
  }, []);

  return (
    <TeamDashboardWalkthroughContext.Provider
      value={{
        manualTeamDashboardRequest,
        requestManualTeamDashboardWalkthrough,
      }}
    >
      {children}
    </TeamDashboardWalkthroughContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components -- hook paired with TeamDashboardWalkthroughProvider
export function useTeamDashboardWalkthroughContext(): TeamDashboardWalkthroughContextValue {
  const ctx = useContext(TeamDashboardWalkthroughContext);
  if (!ctx) {
    throw new Error(
      'useTeamDashboardWalkthroughContext must be used within TeamDashboardWalkthroughProvider',
    );
  }
  return ctx;
}
